export default __webpack_public_path__ + "static/media/sampleresume.a89bf457.png";